// Fælles stil for alle figurer: farver, stregtykkelser, skriftstørrelser,
// pile (SVG-markers) og rammen omkring hver figur.

export const C = {
  rust: '#B5531E', // varmt vand, fremhævning
  dark: '#221E1B', // konturer, labels
  grey: '#6B625B', // koldt vand, sekundær tekst
  light: '#F3E6DC', // flader
  line: '#E6DED5', // hjælpelinjer, flader
  page: '#F7F3EE', // sidens baggrund
};

export const STROKE = { outline: 2, secondary: 1.25 };
export const FONT = { name: 13, note: 12 };
export const FIG_WIDTH = 360;

// Pile: url(#<figur-id>-hot | -cold | -dark)
export const arrow = (id, kind) => `url(#${id}-${kind})`;

function Marker({ id, kind, color }) {
  return (
    <marker
      id={`${id}-${kind}`}
      viewBox="0 0 10 10"
      refX="7"
      refY="5"
      markerWidth="9"
      markerHeight="9"
      markerUnits="userSpaceOnUse"
      orient="auto-start-reverse"
    >
      <path d="M1.5,1.5 L8,5 L1.5,8.5 Z" fill={color} stroke={color} strokeWidth="1" strokeLinejoin="round" />
    </marker>
  );
}

// Lodret farveovergang fra varmt til koldt vand (til streger)
export function WaterGradient({ id, y1, y2 }) {
  return (
    <linearGradient id={id} gradientUnits="userSpaceOnUse" x1="0" y1={y1} x2="0" y2={y2}>
      <stop offset="0" stopColor={C.rust} />
      <stop offset="1" stopColor={C.grey} />
    </linearGradient>
  );
}

export function Label({ x, y, kind = 'name', anchor = 'start', lines }) {
  const isName = kind === 'name';
  const size = isName ? FONT.name : FONT.note;
  return (
    <text
      x={x}
      y={y}
      textAnchor={anchor}
      fontSize={size}
      fontWeight={isName ? 500 : 400}
      fill={isName ? C.dark : C.grey}
    >
      {lines.map((line, i) => (
        <tspan key={i} x={x} dy={i === 0 ? 0 : size + 4}>
          {line}
        </tspan>
      ))}
    </text>
  );
}

export function Leader({ points }) {
  return <polyline points={points} fill="none" stroke={C.grey} strokeWidth={STROKE.secondary} />;
}

// Termostatventil set forfra: ventilhus på røret med termostathovedet ovenpå.
export function ThermostatValve({ cx, pipeY }) {
  return (
    <g>
      <rect x={cx - 11} y={pipeY - 44} width="22" height="32" rx="6" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />
      <line x1={cx - 6} y1={pipeY - 34} x2={cx + 6} y2={pipeY - 34} stroke={C.grey} strokeWidth={STROKE.secondary} />
      <line x1={cx - 6} y1={pipeY - 27} x2={cx + 6} y2={pipeY - 27} stroke={C.grey} strokeWidth={STROKE.secondary} />
      <rect x={cx - 5} y={pipeY - 12} width="10" height="4" fill={C.line} stroke={C.dark} strokeWidth={STROKE.secondary} />
      <rect x={cx - 13} y={pipeY - 8} width="26" height="16" rx="3" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
    </g>
  );
}

export function Figure({ id, title, caption, height, defs, children }) {
  return (
    <figure className="my-8">
      <div className="bg-[#F7F3EE] border border-[#E6DED5] rounded p-2 sm:p-4 flex justify-center">
        <svg
          viewBox={`0 0 ${FIG_WIDTH} ${height}`}
          role="img"
          aria-labelledby={`${id}-title`}
          className="w-full max-w-[440px] h-auto"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <title id={`${id}-title`}>{title}</title>
          <defs>
            <Marker id={id} kind="hot" color={C.rust} />
            <Marker id={id} kind="cold" color={C.grey} />
            <Marker id={id} kind="dark" color={C.dark} />
            {defs}
          </defs>
          {children}
        </svg>
      </div>
      <figcaption className="text-sm text-[#6B625B] mt-2 italic text-center">{caption}</figcaption>
    </figure>
  );
}
